import { Injectable } from '@angular/core';
import { Constants } from '../util/constants';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../models/user.model';
import { ReportListRequest } from '../models/reportlistrequest.model';

@Injectable({
  providedIn: 'root'
})
export class TBBO2RecoveryTimeReportDataService {

  constructor(private http: HttpClient) { }

	getSessionsForReportList(reportlistrequest : ReportListRequest ,loggedUser:User): Observable<any> {
			var auth: string ='Bearer' + ' ' + loggedUser.Token
			const httpOptions = {
				headers: new HttpHeaders({
					'authorization': auth,
					'Accept': 'application/json',
					'Content-type': 'application/json'
				})
			}
			return this.http.post<any>(environment.server_URL+ environment.router_prefix + '/getsessionsforreportlist',JSON.stringify(reportlistrequest) , httpOptions).pipe()
	}

  	getreportforpreview(sessionid : string, loggedUser:User): Observable<any> {
		var auth: string ='Bearer' + ' ' + loggedUser.Token
		const httpOptions = {
			headers: new HttpHeaders({
				'authorization': auth,
				'Accept': 'application/pdf',
				'Content-type': 'application/json'

			}),
			responseType: 'arraybuffer'
		}

		return this.http.post(environment.server_URL+ environment.router_prefix + '/gettbbo2therapysessionreport/' + sessionid ,JSON.stringify({UserID:loggedUser.UserID}) , {
			headers: new HttpHeaders({
				'authorization': auth,
				'Accept': 'application/pdf',
				'Content-type': 'application/json'
			}),
			responseType: 'arraybuffer'
		}) // had to add inline httpoptions
	}

	gettbbo2recoverytimereport(sessions : any, loggedUser:User): Observable<any> {
		var auth: string ='Bearer' + ' ' + loggedUser.Token
		const httpOptions = {
			headers: new HttpHeaders({
				 'authorization': auth,
				 'Accept': 'application/pdf',
				 'Content-type': 'application/json'

			}),
			responseType: 'arraybuffer'
		}

		 return this.http.post(environment.server_URL+ environment.router_prefix + '/gettbbo2recoverytimereport/'+ loggedUser.UserID,JSON.stringify(sessions) , {
			headers: new HttpHeaders({
				 'authorization': auth,
				 'Accept': 'application/pdf',
				 'Content-type': 'application/json'
			}),
			responseType: 'arraybuffer'
		}) // had to add inline httpoptions
	}

}
